import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../auth.service';
import { AppConstants } from '../config.service';
declare const ITHit;

@Injectable({
    providedIn: 'root'
})
export class DocumentHandlingService {

    constructor(
        private service: SharedService,
        public translate: TranslateService,
        public toastr: ToastService,
        private authservice:AuthService,
        private keycloakService: KeycloakService,
        private appConstants : AppConstants
    ) {
        this.checkSprigDeviceStatus();
        this.getUserInfo();
    }

    userInfo: any = {};
     getUserInfo() {
            const user = this.appConstants.userDetails
            this.userInfo = user;
    }

    selectedDevice: any = {};
    isSprigEnabled: boolean = false;
    checkSprigDeviceStatus() {
        return new Promise((resolve, reject) => {
            if (localStorage.getItem('selectedDevice'))
                this.selectedDevice = JSON.parse(localStorage.getItem('selectedDevice'));
            if (localStorage.getItem('isSprigEnabled')) {
                this.isSprigEnabled = JSON.parse(localStorage.getItem('isSprigEnabled'));
            }
            resolve('success')
        });
    }


    isEditInPlace(doc) {
        if (this.isSprigEnabled) {
            if (this.ValidateFileExtensions(doc.name))
                return 'edit';
            else
                return 'download';
        }
        else
            this.toastr.warning(this.translate.instant('administration_documentServiceNotAvailable_label'));
    }


    editInPlace(doc) {
        let selectedDevice = JSON.parse(localStorage.getItem('selectedDevice'));
        this.selectedDevice = selectedDevice;
        if (selectedDevice && selectedDevice.basePathUrl && selectedDevice.installationId) {
            return new Promise((resolve, reject) => {
                this.checkSprigDeviceStatus().then(res => {
                    const userName = this.userInfo.email;
                    if (this.isEditInPlace(doc) == "edit") {
                        //   this.checkReadiness(doc.id, selectedDevice).then(checkFileStatus => {
                        //    if (checkFileStatus) {
                        if (this.selectedDevice.webDavUrl != null) {
                            let sDocumentUrl = this.stripEndingSlash(this.selectedDevice.webDavUrl) + "/User_" + userName + "/" + doc.id + "_123" + "/" + doc.name;
                            ITHit.WebDAV.Client.DocManager.EditDocument(sDocumentUrl, "/", this.protocolInstallCallback);
                            resolve('done');
                        }
                        else {
                            this.goDownload(doc).then(res => {
                                resolve('done');
                            })
                        }
                        //    }
                        //  })
                    }
                    else if (this.isEditInPlace(doc) == "download") {
                        this.goDownload(doc).then(res => {
                            resolve('done');
                        })
                    }
                })

            })
        }
        else
            this.authservice.checksprigAvailable.next({ sprigNotAvailable: true, modalTitle: this.translate.instant('administration_unableToEditDocuments_label') })
    }

    // Called if protocol handler is not installed
    protocolInstallCallback(message) {
        let installerFilePath = "assets/WebDAV/Plugins/" + ITHit.WebDAV.Client.DocManager.GetInstallFileName();
        const protocolMsg = this.translate.instant('administration_protocolInstallationMsg_label');

        if (confirm(protocolMsg)) {
            window.open(installerFilePath);
        }
    }
    stripEndingSlash(s) {
        if (s != "" && s.endsWith("/")) {
            s = s.substring(0, s.length - 1);
        }
        return s;
    }

    ValidateFileExtensions(sFileName) {
        let _validFileExtensions = [".docx", ".doc", ".docm", ".dot", ".dotm", ".dotx",
            ".xltx", ".xltm", ".xlt", ".xlsx", ".xlsm", ".xlsb", ".xls", ".xll", ".xlam", ".xla",
            ".pptx", ".pptm", ".ppt", ".ppsx", ".ppsm", ".pps", ".ppam", ".ppa", ".potx", ".potm", ".pot",
            ".accdb", ".mdb",
            ".xsn", ".xsf",
            ".pub",
            ".vstx", ".vstm", ".vst", ".vssx", ".vssm", ".vssm", ".vss", ".vsl", ".vsdx", ".vsdm", ".vsd", ".vdw",
            ".mpp",
            ".odt",
            ".ods",
            ".odp"];
        if (sFileName.length > 0) {
            let blnValid = false;
            for (let j = 0; j < _validFileExtensions.length; j++) {
                let sCurExtension = _validFileExtensions[j];
                if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }
            if (!blnValid) {
                // alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + _validFileExtensions.join(", "));
                return false;
            }
        }
        return true;
    }

    goDownload(doc?: any) {
        const getLocalSprig = localStorage.getItem('selectedDevice')
        const selectedDevice = getLocalSprig ? JSON.parse(getLocalSprig) : null;
        this.selectedDevice = selectedDevice;
        if (selectedDevice && selectedDevice.basePathUrl && selectedDevice.installationId) {
            return new Promise((resolve, reject) => {
                this.checkSprigDeviceStatus().then(res => {
                    const userName = this.userInfo.email;
                    this.service
                        .getFile(this.selectedDevice.basePathUrl + '/documents/download/' + doc.id + "?userName=" + userName, {})
                        .subscribe(data => {
                            if (data != null) {
                                let url = window.URL.createObjectURL(new Blob([data]));
                                let a = window.document.createElement('a');
                                a.href = url;
                                a.download = doc.filename;
                                // a.target = '_blank';
                                document.body.appendChild(a);
                                a.click();
                                setTimeout(function () {
                                    window.URL.revokeObjectURL(url);
                                }, 100);
                            }
                            else
                                this.toastr.error(this.translate.instant('administration_fileNotFound_label'));
                            resolve(data)
                        }, res => {
                            reject("error")
                            res.error = JSON.parse(res.error);
                        });
                });
            });
        }
        else
            this.authservice.checksprigAvailable.next({ sprigNotAvailable: true, modalTitle: this.translate.instant('administration_unableToDownloadDocuments_label') })
    }

}